import jquery from "jquery";
import jqueryBridget from "jquery-bridget";

// import Flickity from "flickity";
const Flickity = require('flickity');
require('flickity-fade');
require('flickity-as-nav-for');
require('flickity-sync');

// import "lazysizes";
// import "lazysizes/plugins/respimg/ls.respimg";
// import "lazysizes/plugins/rias/ls.rias";
// import "lazysizes/plugins/bgset/ls.bgset";
// import "lazysizes/plugins/object-fit/ls.object-fit";
// import "lazysizes/plugins/parent-fit/ls.parent-fit";

window.$ = window.jQuery = jquery;
window.Flickity = window.flickity = Flickity;
Flickity.setJQuery($);
jqueryBridget('flickity', Flickity, $);